<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "magic-scroll-provider" };
import { provide, computed } from "vue";
import { useScroll, unrefElement } from "@vueuse/core";
import { MagicScrollReturn, MagicScrollTarget } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicScrollProvider",
  props: {
    target: { type: null, required: false }
  },
  setup(__props) {
    const mappedTarget = computed(() => {
      switch (true) {
        case !!__props.target:
          return unrefElement(__props.target);
        case typeof window !== "undefined":
          return window;
        default:
          return void 0;
      }
    });
    const providedTarget = computed(() => {
      if (__props.target) {
        return unrefElement(__props.target);
      }
      return void 0;
    });
    const scrollReturn = useScroll(mappedTarget);
    provide(MagicScrollReturn, scrollReturn);
    provide(MagicScrollTarget, providedTarget);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", { scrollReturn: _unref(scrollReturn) })
      ]);
    };
  }
});
</script>
